import { Box, Stack } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { Form } from '../components/form/Form';
import { useSelector } from 'react-redux';
import ConfirmDialog from '../components/common/Confirm.component';
import ConfirmButton from '../components/actions/ConfirmButton';

const ActionView = ({ action, tag, onSubmitAction, success }) => {
  const {
    list: { selected },
  } = useSelector((state) => state[tag]);

  const {
    conf: { schema, fields, defaultValues },
  } = action;

  const [open, setOpen] = useState(false);
  const [values, setValues] = useState(null);
  const onClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  const onOpen = useCallback(
    (data) => {
      setOpen(true);
      setValues(data);
    },
    [setOpen]
  );

  const onSubmit = useCallback(() => {
    const listId = selected && Object.values(selected).flat();
    onSubmitAction({ ids: listId, ...values });
  }, [selected, onSubmitAction, values]);

  useEffect(() => {
    if (success) setOpen(false);
  }, [success]);
  return (
    <Form
      fields={fields}
      schema={schema}
      defaultValues={defaultValues}
      onSubmit={onOpen}
    >
      <Box width={1} display={'flex'} justifyContent='flex-end'>
        <Stack direction={'row'} spacing={1} sx={{ mt: 1, mb: 1 }}>
          <ConfirmButton />

          <ConfirmDialog
            open={open}
            onClose={onClose}
            title='Are you sure you want to update all rows selected?'
            description='This action is permanently. You cannot undo this action.'
            cancelAction={onClose}
            confirmAction={onSubmit}
            color='info'
            label='Confirm'
          />
        </Stack>
      </Box>
    </Form>
  );
};

export default ActionView;
